import PropTypes from "prop-types";
import MyGallery from "@components/ReactImageGallery/MyGallery";
import useTranslations from "@hooks/useTranslations";
import { useLanguage } from "@contexts/LanguageContext";
import { ICONS } from "@utils/icons";

const PortfolioModal = ({ element, modalId, renderGallery = true }) => {
  const t = useTranslations();
  const { lang } = useLanguage();
  const description =
    lang === "en" && element.description_en
      ? element.description_en
      : element.description;
  const isGithubLink = element.linkType === "github";
  const titleId = `${modalId}-title`;

  return (
    <div
      className="modal portfolio-modal-box fade"
      id={modalId}
      tabIndex={-1}
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="close"
              data-bs-dismiss="modal"
              aria-label={t.a11y.closeModal}
            >
              <i className={ICONS.close} aria-hidden="true" />
            </button>
          </div>
          <div className="modal-body">
            <h6 className="blog-title" id={titleId}>
              {element.nom}
            </h6>
            <div className="portfolio-modal-table">
              <div className="row">

                <div className="col-md-12">
                  <h3 className="portfolio-modal-table-text">
                    <i className={ICONS.technologies} />
                    {t.portfolio.technologies}
                  </h3>
                  <div className="d-flex flex-wrap gap-2 pt-3">
                    {element.technologies.map((tech) => (
                      <div
                        key={`${element.nom}-${tech.nom}`}
                        className="d-flex flex-column gap-2 align-items-center"
                      >
                        <img src={tech.image} alt={tech.nom} height="50px" width="auto" />
                        <span style={{ fontSize: "0.7em" }}>{tech.nom}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="col-md-12">
                  <h3 className="portfolio-modal-table-text">
                    {t.portfolio.description}
                  </h3>
                  <p>{description}</p>
                </div>

                {element.link && (
                  <div className="col-md-12 mt-3">
                    <a
                      href={element.link}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-primary"
                    >
                      <i className={isGithubLink ? ICONS.github : ICONS.website} />{" "}
                      {isGithubLink ? t.portfolio.github : t.portfolio.website}
                    </a>
                  </div>
                )}

                {!element.link && element.privateCode && (
                  <div className="col-md-12 mt-3">
                    <p className="card-text">
                      <i className={ICONS.lock} aria-hidden="true" />{" "}
                      {t.portfolio.privateCode}
                    </p>
                  </div>
                )}

              </div>
            </div>

            <div className="h1-modal-img">
              {renderGallery && (
                <MyGallery
                  images={element.galerie.map((img) => ({
                    original: img,
                    thumbnail: img,
                    originalAlt: element.nom,
                    thumbnailAlt: element.nom,
                  }))}
                  thumbnailPosition="bottom"
                  autoPlay={true}
                  lazyLoad={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

PortfolioModal.propTypes = {
  element: PropTypes.shape({
    nom: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    description_en: PropTypes.string,
    galerie: PropTypes.arrayOf(PropTypes.string).isRequired,
    technologies: PropTypes.arrayOf(
      PropTypes.shape({
        nom: PropTypes.string.isRequired,
        image: PropTypes.string.isRequired,
      })
    ).isRequired,
    link: PropTypes.string,
    linkType: PropTypes.oneOf(["github", "website"]),
    /** Code non publiable (propriété du client) : affiche une mention explicite. */
    privateCode: PropTypes.bool,
  }).isRequired,
  modalId: PropTypes.string.isRequired,
  /** Monte la galerie. Différé jusqu'à la première ouverture de la modale. */
  renderGallery: PropTypes.bool,
};

export default PortfolioModal;
